module.exports = __webpack_public_path__ + "img/icons8-hyundai.777a3837.svg";